/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-22 16:17:49
 * @Explain: 语言配置
 */
export default {
  'COMMON.LANG.ar': 'Arabic',
  'COMMON.LANG.de': 'German',
  'COMMON.LANG.en': 'English',
  'COMMON.LANG.en-GB': 'English (United Kingdom)',
  'COMMON.LANG.en-US': 'English (United States)',
  'COMMON.LANG.es': 'Spanish',
  'COMMON.LANG.es-MX': 'Spanish (Mexico)',
  'COMMON.LANG.fr': 'French',
  'COMMON.LANG.id': 'Indonesian',
  'COMMON.LANG.it': 'Italian',
  'COMMON.LANG.ja': 'Japanese',
  'COMMON.LANG.ko': 'Korean',
  'COMMON.LANG.ms': 'Malay',
  'COMMON.LANG.pl': 'Polish',
  'COMMON.LANG.pt': 'Portuguese',
  'COMMON.LANG.pt-BR': 'Portuguese (Brazil)',
  'COMMON.LANG.ru': 'Russian',
  'COMMON.LANG.th': 'Thai',
  'COMMON.LANG.tr': 'Turkish',
  'COMMON.LANG.vi': 'Vietnamese',
  'COMMON.LANG.zh-Hans': 'Chinese, Simplified',
  'COMMON.LANG.zh-Hant': 'Chinese, Traditional (Hong Kong)',
  'COMMON.LANG.zh-CN': "Chinese (People's Republic of China)",
  'COMMON.LANG.zh-HK': 'Chinese, Traditional (Hong Kong)',
  'COMMON.LANG.zh-TW': 'Chinese, Traditional (Taiwan)',
  'COMMON.LANG.cs': 'Czech',
  'COMMON.LANG.fi': 'Finnish',
  'COMMON.LANG.fil-PH': 'Filipino',
  'COMMON.LANG.hi': 'Hindi',
  'COMMON.LANG.nl': 'Dutch',
  'COMMON.LANG.ur': 'Urdu',
  'COMMON.LANG.uz': 'Uzbek',
  'COMMON.LANG.un-Know': 'Unknown Language',
};
